var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"preloader"}},[_c('div',{staticClass:"fake-assets"}),_c('div',{staticClass:"fake-options"}),_c('div',{staticClass:"fake-viewer"})])
}]

export { render, staticRenderFns }